@if (content) {
<div>
    <p class="s1"
       *iCms="'heading' of content"></p>
    <p class="p2 m-t-1"
       *iCms="'copy' of content"></p>
</div>
}
